import type { Locale } from 'antd/lib/locale';
import enUS from 'antd/locale/en_US';
import plPL from 'antd/locale/pl_PL';
import elGr from 'antd/locale/el_GR';
import etEe from 'antd/locale/et_EE';
import ltLT from 'antd/locale/lt_LT';

export const detectLocale = (locale: string) => {
  const locales: { [key: string]: Locale } = {
    en: enUS,
    pl: plPL,
    el: elGr,
    et: etEe,
    lt: ltLT,
  };
  const formattedLang = locale.split('-')[0];
  return locales[formattedLang] || enUS;
};
